import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Chart } from 'chart.js';
import { DashboardService } from '../padufa/dashboard.service';
import { ToastMessageService } from 'src/app/toastr.service';
import { HomeService } from '../home/home.services';
@Component({
  selector: 'app-peak-sale',
  templateUrl: './peak-sale.component.html',
  styleUrls: ['./peak-sale.component.scss']
})
export class PeakSaleComponent {
activeTab = 'analog';

  drugInfoForm: FormGroup;
  analogForm: FormGroup;
  epidemiologyForm: FormGroup;
  marketShareForm: FormGroup;
  regressionForm: FormGroup;
  scenarioForm: FormGroup;
  monteCarloForm: FormGroup;

  showAnalogResults = false;
  showEpiResults = false;
  showMarketResults = false;
  showRegressionResults = false;
  showScenarioResults = false;
  showMonteCarloResults = false;

  brandname = "";
  MoleculeData1: any = [];
  submolecules: any[] = [];
  nda_number: any;
  subMolecule = false;
  Molecule = false;
  DragData: any = {};
  selectedSubMolecule: any = {};
  psData: any;

  modalCompleted: {
    value: any;
    isCompleted: boolean;
    ps_method: string;
  }[] = [{
    value: {},
    isCompleted: false,
    ps_method: 'analog based forecast'
  },{
    value: {},
    isCompleted: false,
    ps_method: 'epidemiology based forecast'
  },{
    value: {},
    isCompleted: false,
    ps_method: 'market share based forecast'
  },{
    value: {},
    isCompleted: false,
    ps_method: 'regression based forecast'
  },{
    value: {},
    isCompleted: false,
    ps_method: 'scenario based forecast'
  },{
    value: {},
    isCompleted: false,
    ps_method: 'monte carlo simulation'
  }];
  constructor(private formBuilder: FormBuilder, private dashboardService: DashboardService, private toastService: ToastMessageService, private homeservice: HomeService) {
    this.drugInfoForm = this.formBuilder.group({
      // drugName: ['',],
      // therapeuticArea: [''],
      // targetMarket: [''],
      timeframe: ['',Validators.required]
    });

    this.analogForm = this.formBuilder.group({
      // analogDrug: ['',[Validators.required]],
      analogPeakSales: [null, [Validators.min(0),Validators.required]],
      analogPeakShare: [null, [Validators.min(0), Validators.max(100),Validators.required]],
      analogYearsToPeak: [null, [Validators.min(1),Validators.required]],
      populationRatio: [null,Validators.required],
      pricePremium: [null,Validators.required],
      alpha: [null, Validators.required],
      beta: [null, Validators.required]
    });

    this.epidemiologyForm = this.formBuilder.group({
      diseasePrevalence: [null,Validators.required],
      population: [null,Validators.required],
      diagnosisRate: [null, [Validators.min(0), Validators.max(100),Validators.required]],
      treatmentRate: [null, [Validators.min(0), Validators.max(100),Validators.required]],
      eligibilityRate: [null, [Validators.min(0), Validators.max(100),Validators.required]],
      epiMarketShare: [null, [Validators.min(0), Validators.max(100),Validators.required]],
      annualCost: [null, [Validators.min(0),Validators.required]],
      persistenceRate: [null, [Validators.min(0), Validators.max(1),Validators.required]]
    });

    this.marketShareForm = this.formBuilder.group({
      totalMarket: [null],
      marketPeakShare: [null, [Validators.min(0), Validators.max(100)]],
      marketYearsToPeak: [null, [Validators.min(1)]],
      marketGrowth: [null],
      erosionRate: [null]
    });

    this.regressionForm = this.formBuilder.group({
      severityScore: [null, [Validators.min(1), Validators.max(10)]],
      regressionCost: [null, [Validators.min(0)]],
      competitiveIndex: [null, [Validators.min(1), Validators.max(5)]],
      patientPopSize: [null, [Validators.min(0)]],
      regulatoryScore: [null, [Validators.min(1), Validators.max(10)]],
      alpha: [null, Validators.required],
      beta1: [null, Validators.required],
      beta2: [null, Validators.required],
      beta3: [null, Validators.required],
      beta4: [null, Validators.required],
      beta5: [null, Validators.required]
    });

    this.scenarioForm = this.formBuilder.group({
      baseUptake: [null],
      basePrice: [null],
      baseGrowth: [null],
      baseProbability: [null],
      optUptake: [null],
      optPrice: [null],
      optGrowth: [null],
      optProbability: [null],
      pessUptake: [null],
      pessPrice: [null],
      pessGrowth: [null],
      pessProbability: [null],
      patientCount: [null, Validators.required]
    });

    this.monteCarloForm = this.formBuilder.group({
      growthMean: [null,Validators.required ],
      growthStd: [null,Validators.required],
      priceMin: [null,Validators.required],
      priceMax: [null,Validators.required],
      penetrationMin: [null,Validators.required],
      penetrationMode: [null,Validators.required],
      penetrationMax: [null,Validators.required],
      numSimulations: ['',Validators.required],
      basePatientCount: [null, Validators.required]
    });
  }

  ngOnInit() {
    this.dashboardService.psCalculate().subscribe((res) => {
      this.psData = res?.[0];
   

      
          this.regressionForm.patchValue({
        alpha: this.psData?.regression_based_forecast?.alpha,
        beta1: this.psData?.regression_based_forecast?.beta1,
        beta2: this.psData?.regression_based_forecast?.beta2,
        beta3: this.psData?.regression_based_forecast?.beta3,
        beta4: this.psData?.regression_based_forecast?.beta4,
        beta5: this.psData?.regression_based_forecast?.beta5
      });
      this.monteCarloForm.patchValue({
        basePatientCount: this.psData?.monte_carlo_simulation?.base_patient
      });
      this.drugInfoForm.patchValue({
        timeframe: this.psData?.timeframe
      });
      this.scenarioForm.patchValue({
        patientCount: this.psData?.scenario_based_forecast?.base_patient
      });
      this.analogForm.patchValue({
        alpha: this.psData?.analog_based_forecast?.alpha,
        beta: this.psData?.analog_based_forecast?.beta
      });

      console.log("psData", this.psData);
      
    });
  }
  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  initializeAnalysis() {
    // Placeholder for initializing all models based on drug info
    // Could prefill forms or trigger validations
  }

  calculateAnalogForecast() {
    this.markFormGroupTouched(this.analogForm);
    console.log("this.analogForm.value", this.analogForm.value);
    if (this.analogForm.valid) {
      // this.showAnalogResults = true;
      var data = {
        "analog_peak_sales": this.analogForm.value.analogPeakSales,
        "analog_peak_share": this.analogForm.value.analogPeakShare, 
        "analog_years_to_peak": this.analogForm.value.analogYearsToPeak,
        "population_ratio":this.analogForm.value.populationRatio,
        "price_premium" :this.analogForm.value.pricePremium,
        "timeframe" :this.drugInfoForm.value.timeframe,
        "alpha" :this.analogForm.value.alpha,
        "beta": this.analogForm.value.beta,
        "start_year" :"2025",
        "ps_method": "analog based forecast",
        "brand_name": this.selectedSubMolecule?.code?.brand_name || null,
        "nda_number": this.selectedSubMolecule?.code?.nda_number || null,
        "dosage_forms": this.selectedSubMolecule?.code?.dosage_forms || null,
        "active_ingredient":this.DragData?.active_ingredient || null
      }

      console.log("data", this.analogForm.value);

      this.dashboardService.psCalculatePost(data).subscribe((res) => {
        console.log("res", res);
        this.toastService.success(res?.message);
        const findIndex = this.modalCompleted.findIndex(item => item.ps_method === "analog based forecast");
        console.log("findIndex", findIndex)
        console.log("this.modalCompleted", data)
        this.modalCompleted[findIndex] = {
          ps_method: "analog based forecast",
          value: {
            ...this.analogForm.value,
            ...res
          },
          isCompleted: true
        };
      });

    }
  }

  calculateEpidemiologyForecast() {
    this.markFormGroupTouched(this.epidemiologyForm);
    if (this.epidemiologyForm.valid) {
      // this.showEpiResults = true;
          var data =  {
            "prevalence": this.epidemiologyForm.value.diseasePrevalence,
            "population": this.epidemiologyForm.value.population, 
            "diagnosis_rate": this.epidemiologyForm.value.diagnosisRate,
            "treatment_rate": this.epidemiologyForm.value.treatmentRate,
            "eligibility_rate" : this.epidemiologyForm.value.eligibilityRate,
            "timeframe" : this.drugInfoForm.value.timeframe,
            "market_share" : this.epidemiologyForm.value.epiMarketShare,
            "annual_cost" : this.epidemiologyForm.value.annualCost,
            "persistence_rate": this.epidemiologyForm.value.persistenceRate,
            "start_year" : "2025",
            "ps_method": "epidemiology based forecast",
            "brand_name": this.selectedSubMolecule?.code?.brand_name || null,
            "nda_number": this.selectedSubMolecule?.code?.nda_number || null,
            "dosage_forms": this.selectedSubMolecule?.code?.dosage_forms || null,
            "active_ingredient":this.DragData?.active_ingredient || null
        }

      console.log("data", this.analogForm.value);

      this.dashboardService.psCalculatePost(data).subscribe((res) => {
        console.log("res", res);
        this.toastService.success(res?.message);
        const findIndex = this.modalCompleted.findIndex(item => item.ps_method === "epidemiology based forecast");
        this.modalCompleted[findIndex] = {
          ps_method: "epidemiology based forecast",
          value: {
            ...this.epidemiologyForm.value,
            ...res
          },
          isCompleted: true
        };
      });
    }
  }

  calculateMarketShareForecast() {
    this.markFormGroupTouched(this.marketShareForm);
    if (this.marketShareForm.valid) {
      // this.showMarketResults = true;
        var data =  {
           "prevalence": this.marketShareForm.value.totalMarket,
            "total_market": this.marketShareForm.value.totalMarket,
            "peak_share": this.marketShareForm.value.marketPeakShare, 
            "years_to_peak": this.marketShareForm.value.marketYearsToPeak,
            "market_growth": this.marketShareForm.value.marketGrowth,
            "erosion_rate" : this.marketShareForm.value.erosionRate,
            "timeframe" : this.drugInfoForm.value.timeframe,
            "start_year" :"2025",
            "ps_method": "market share based forecast",
            "brand_name": this.selectedSubMolecule?.code?.brand_name || null,
            "nda_number": this.selectedSubMolecule?.code?.nda_number || null,
            "dosage_forms": this.selectedSubMolecule?.code?.dosage_forms || null,
            "active_ingredient":this.DragData?.active_ingredient || null
        }

      console.log("data", this.marketShareForm.value);

      this.dashboardService.psCalculatePost(data).subscribe((res) => {
        console.log("res", res);
        this.toastService.success(res?.message);
        const findIndex = this.modalCompleted.findIndex(item => item.ps_method === "market share based forecast");
        this.modalCompleted[findIndex] = {
          ps_method: "market share based forecast",
          value: {
            ...this.marketShareForm.value,
            ...res
          },
          isCompleted: true
        };
      });
    }
  }

  calculateRegressionForecast() {
    this.markFormGroupTouched(this.regressionForm);
    if (this.regressionForm.valid) {
      // this.showRegressionResults = true;
        var data =  {
          "severity_score": this.regressionForm.value.severityScore,
          "treatment_cost": this.regressionForm.value.regressionCost, 
          "competitive_index": this.regressionForm.value.competitiveIndex,
          "patient_pop_size": this.regressionForm.value.patientPopSize,
          "regulatory_score" : this.regressionForm.value.regulatoryScore,
          "alpha" :this.regressionForm.value?.alpha,
          "beta1" : this.regressionForm.value?.beta1,
          "beta2" : this.regressionForm.value?.beta2,
          "beta3" : this.regressionForm.value?.beta3,
          "beta4" : this.regressionForm.value?.beta4,
          "beta5" : this.regressionForm.value?.beta5,
          "timeframe" : this.drugInfoForm.value.timeframe,
          "start_year" :"2025",
          "ps_method": "regression based forecast",
          "brand_name": this.selectedSubMolecule?.code?.brand_name || null,
          "nda_number": this.selectedSubMolecule?.code?.nda_number || null,
          "dosage_forms": this.selectedSubMolecule?.code?.dosage_forms || null,
          "active_ingredient":this.DragData?.active_ingredient || null
        }

      this.dashboardService.psCalculatePost(data).subscribe((res) => {
        console.log("res", res);
        this.toastService.success(res?.message);
        const findIndex = this.modalCompleted.findIndex(item => item.ps_method === "regression based forecast");
        this.modalCompleted[findIndex] = {
          ps_method: "regression based forecast",
          value: {
            ...this.regressionForm.value,
            ...res
          },
          isCompleted: true
        };
      });
    }
  }

  calculateScenarioForecast() {
    this.markFormGroupTouched(this.scenarioForm);
    if (this.scenarioForm.valid) {
     var totalProbability = this.scenarioForm.value.baseProbability + this.scenarioForm.value.optProbability + this.scenarioForm.value.pessProbability ;
     if(totalProbability !== 100){
      this.toastService.error("Sum of Probability's  must be equal to 100. Base Probability + Optimistic Probability + Pessimistic Probability  = 100 %");
      return;
     }
      // this.showScenarioResults = true;
      var data =  {
              "base_uptake": this.scenarioForm.value.baseUptake,
            "base_price": this.scenarioForm.value.basePrice, 
            "base_growth": this.scenarioForm.value.baseGrowth,
            "base_probability": this.scenarioForm.value.baseProbability,
            "opt_uptake": this.scenarioForm.value.optUptake,
            "opt_price":  this.scenarioForm.value.optPrice, 
            "opt_growth": this.scenarioForm.value.optGrowth,
            "opt_probability": this.scenarioForm.value.optProbability,
            "pess_uptake": this.scenarioForm.value.pessUptake,
            "pess_price": this.scenarioForm.value.pessPrice, 
            "pess_growth": this.scenarioForm.value.pessGrowth,
            "pess_probability": this.scenarioForm.value.pessProbability,
            "patient_count": this.scenarioForm.value.patientCount,
            "timeframe" : this.drugInfoForm.value.timeframe,
            "start_year" :"2025",
            "ps_method": "scenario based forecast",
            "brand_name": this.selectedSubMolecule?.code?.brand_name || null,
            "nda_number": this.selectedSubMolecule?.code?.nda_number || null,
            "dosage_forms": this.selectedSubMolecule?.code?.dosage_forms || null,
            "active_ingredient":this.DragData?.active_ingredient || null
      }
    console.log("data", this.marketShareForm.value);

    this.dashboardService.psCalculatePost(data).subscribe((res) => {
      console.log("res", res);
      this.toastService.success(res?.message);
      const findIndex = this.modalCompleted.findIndex(item => item.ps_method === "regression based forecast");
      console.log("findIndex", findIndex)
      this.modalCompleted[findIndex] = {
        ps_method: "scenario based forecast",
        value: {
          ...this.scenarioForm.value,
          ...res
        },
        isCompleted: true
      };
      console.log("this.modalCompleted", this.modalCompleted)
    },(error) => {
      this.toastService.error(error?.message||"Something went wrong");
    });
    }
  }

  runMonteCarloSimulation() {
    this.markFormGroupTouched(this.monteCarloForm);
    if (this.monteCarloForm.valid) {
      // this.showMonteCarloResults = true;
      var data =  {
          "num_simulations": this.monteCarloForm.value.numSimulations,
          "growth_mean": this.monteCarloForm.value.growthMean,
          "growth_std": this.monteCarloForm.value.growthStd,
          "price_min": this.monteCarloForm.value.priceMin,
          "price_max": this.monteCarloForm.value.priceMax,
          "penetration_min": this.monteCarloForm.value.penetrationMin,
          "penetration_mode": this.monteCarloForm.value.penetrationMode,
          "penetration_max": this.monteCarloForm.value.penetrationMax,
          "start_year":"2025",
          "timeframe": this.drugInfoForm.value.timeframe,
          "base_patients": this.psData?.monte_carlo_simulation?.base_patient,
          "ps_method": "monte carlo simulation",
          "brand_name": this.selectedSubMolecule?.code?.brand_name || null,
          "nda_number": this.selectedSubMolecule?.code?.nda_number || null,
          "dosage_forms": this.selectedSubMolecule?.code?.dosage_forms || null,
          "active_ingredient":this.DragData?.active_ingredient || null
      }

      this.dashboardService.psCalculatePost(data).subscribe((res) => {
      console.log("res", res);
      this.toastService.success(res?.message);
      const findIndex = this.modalCompleted.findIndex(item => item.ps_method === "monte carlo simulation");
      this.modalCompleted[findIndex] = {
        ps_method: "monte carlo simulation",
        value: {
          ...this.regressionForm.value,
          ...res
        },
        isCompleted: true
      };
      });
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      control?.markAsTouched();
    });
  }
  get completedCount(): number {
    return this.modalCompleted.filter(item => item.isCompleted).length;
  }
  get peakRange(): number {
    const completed = this.modalCompleted.find(item => item.isCompleted && item.value && item.ps_method === "analog based forecast");
    return completed ? completed?.value?.['analog based forecast response']?.peakRevenue : 0;
  }
  get peakRangeEpidemiology(): number {
    const completed = this.modalCompleted.find(item => item.isCompleted && item.value && item.ps_method === "epidemiology based forecast");
    return completed ? completed?.value?.['epidemiology based forecast response']?.peakRevenue : 0;
  }
  get peakRangeMarketShare(): number {
    const completed = this.modalCompleted.find(item => item.isCompleted && item.value && item.ps_method === "market share based forecast");
    return completed ? completed?.value?.['market share based forecast response']?.peakRevenue : 0;
  } 
  get peakRangeRegression(): number {
      const completed = this.modalCompleted.find(item => item.isCompleted && item.value && item.ps_method === "regression based forecast");
    return completed ? completed?.value?.['regression based forecast response']?.peakRevenue : 0;
  }
  get peakRangeScenario(): number {
    const completed = this.modalCompleted.find(item => item.isCompleted && item.value && item.ps_method === "scenario based forecast");
    return completed ? completed?.value?.['scenario based forecast response']?.peakRevenue : 0;
  }     
  get peakRangeMonteCarlo(): number {
    const completed = this.modalCompleted.find(item => item.isCompleted && item.value && item.ps_method === "monte carlo simulation");
    return completed ? completed?.value?.['monte carlo simulation response']?.peakRevenue : 0;
  }


  get analogSummaryRevenue(): any {
    const completed = this.modalCompleted.find(item => item.isCompleted && item.value && item.ps_method === "analog based forecast");
    return completed ? completed?.value : {};
  }
  get epidemiologySummaryRevenue(): any {
    const completed = this.modalCompleted.find(item => item.isCompleted && item.value && item.ps_method === "epidemiology based forecast");
    return completed ? completed?.value : {};
  }
  get marketShareSummaryRevenue(): any {
    const completed = this.modalCompleted.find(item => item.isCompleted && item.value && item.ps_method === "market share based forecast");
    return completed ? completed?.value : {};
  }
  get regressionSummaryRevenue(): any {
    const completed = this.modalCompleted.find(item => item.isCompleted && item.value && item.ps_method === "regression based forecast");
    return completed ? completed?.value : {};
  }
  get scenarioSummaryRevenue(): any {
    const completed = this.modalCompleted.find(item => item.isCompleted && item.value && item.ps_method === "scenario based forecast");
    return completed ? completed?.value : {};
  }
  get monteCarloSummaryRevenue(): any {
    const completed = this.modalCompleted.find(item => item.isCompleted && item.value && item.ps_method === "monte carlo simulation");
    return completed ? completed?.value : {};
  }

  arrayToDropdown(InputArray: any) {
    let DropDownArray = [];
    InputArray.forEach((DropdownValues: any) => {
      let dropDownObj = {
        name: `${DropdownValues.brand_name},${DropdownValues.nda_number},${DropdownValues.dosage_forms}`,
        code: DropdownValues // store the full object for later use
      };
      DropDownArray.push(dropDownObj);
    });
    return DropDownArray;
  }

  searchMolecule() {
    console.log("searchMolecule")
    this.homeservice.GetNda(this.brandname).subscribe((response) => {
      this.MoleculeData1 = response["data"].nda_numbers;
      if (this.MoleculeData1 != null) {
        let dropdownvalues = this.arrayToDropdown(this.MoleculeData1);
        this.submolecules = dropdownvalues;
        console.log("submolecules", this.submolecules)
        const Array = this.submolecules[0].name.split(",")[1];
        this.nda_number = Array;
        this.subMolecule = true;
        this.Molecule = false;
        this.DragData = {};
      } else {
        this.selectedSubMolecule = {};
        this.subMolecule = false;
        this.Molecule = false;
        this.DragData = {};
      }
    });
  }
  getData() {
    console.log("getData", (this.selectedSubMolecule))
    if(this.selectedSubMolecule !== undefined) {
      let selectedMoleculeData = this.selectedSubMolecule["code"];
      console.log("selectedMoleculeData", selectedMoleculeData)
      if(selectedMoleculeData){
        this.dashboardService.getDrugData(selectedMoleculeData).subscribe((res) => {
          res.user_email = localStorage.getItem("email") || "";

          this.dashboardService.allModuleDataGet(res).subscribe((resModule) => {
            console.log("resModule", resModule)
            this.drugInfoForm.patchValue({
              timeframe: resModule?.timeframe
            });
            this.DragData = resModule;
            this. modalCompleted=  [{
              value: {},
              isCompleted: false,
              ps_method: 'analog based forecast'
            },{
              value: {},
              isCompleted: false,
              ps_method: 'epidemiology based forecast'
            },{
              value: {},
              isCompleted: false,
              ps_method: 'market share based forecast'
            },{
              value: {},
              isCompleted: false,
              ps_method: 'regression based forecast'
            },{
              value: {},
              isCompleted: false,
              ps_method: 'scenario based forecast'
            },{
              value: {},
              isCompleted: false,
              ps_method: 'monte carlo simulation'
            }];
            if(resModule?.["analog based forecast"]){
              this.analogForm.patchValue({
                  alpha: resModule?.["analog based forecast"]?.alpha,
                  beta: resModule?.["analog based forecast"]?.beta,
                  analogPeakSales:resModule?.["analog based forecast"]?.analog_peak_sales,
                  analogPeakShare:resModule?.["analog based forecast"]?.analog_peak_share,
                  analogYearsToPeak:resModule?.["analog based forecast"]?.analog_years_to_peak,
                  populationRatio:resModule?.["analog based forecast"]?.population_ratio,
                  pricePremium:resModule?.["analog based forecast"]?.price_premium
              });
              
            }
            else{
              this.analogForm.patchValue({
                alpha: this.psData?.analog_based_forecast?.alpha,
                beta: this.psData?.analog_based_forecast?.beta
              });
            }
            if(resModule?.["epidemiology based forecast"]){
              this.epidemiologyForm.patchValue({
                diseasePrevalence: resModule?.["epidemiology based forecast"]?.prevalence,
                population: resModule?.["epidemiology based forecast"]?.population,
                diagnosisRate: resModule?.["epidemiology based forecast"]?.diagnosis_rate,
                treatmentRate: resModule?.["epidemiology based forecast"]?.treatment_rate,
                eligibilityRate: resModule?.["epidemiology based forecast"]?.eligibility_rate,
                epiMarketShare: resModule?.["epidemiology based forecast"]?.market_share,
                annualCost: resModule?.["epidemiology based forecast"]?.annual_cost,
                persistenceRate: resModule?.["epidemiology based forecast"]?.persistence_rate
              });
            }
            else{
              this.epidemiologyForm.patchValue({
                diseasePrevalence: "",
                population: "",
                diagnosisRate: "",
                treatmentRate: "",
                eligibilityRate: "",
                epiMarketShare: "",
                annualCost: "",
                persistenceRate: ""
              });
            }
            if(resModule?.["market share based forecast"]){
              this.marketShareForm.patchValue({
                totalMarket: resModule?.["market share based forecast"]?.total_market,
                marketPeakShare: resModule?.["market share based forecast"]?.peak_share,
                marketYearsToPeak: resModule?.["market share based forecast"]?.years_to_peak,
                marketGrowth: resModule?.["market share based forecast"]?.market_growth,
                erosionRate: resModule?.["market share based forecast"]?.erosion_rate
              });
            }
            else{
              this.marketShareForm.patchValue({
                totalMarket: "",
                marketPeakShare: "",
                marketYearsToPeak: "",
                marketGrowth: "",
                erosionRate: ""
              });
            }
            if(resModule?.["regression based forecast"]){
              this.regressionForm.patchValue({
                alpha: resModule?.["regression based forecast"]?.alpha,
                beta1: resModule?.["regression based forecast"]?.beta1,
                beta2: resModule?.["regression based forecast"]?.beta2,
                beta3: resModule?.["regression based forecast"]?.beta3,
                beta4: resModule?.["regression based forecast"]?.beta4,
                beta5: resModule?.["regression based forecast"]?.beta5,
                severityScore: resModule?.["regression based forecast"]?.severity_score,
                regressionCost: resModule?.["regression based forecast"]?.treatment_cost,
                competitiveIndex: resModule?.["regression based forecast"]?.competitive_index,
                patientPopSize: resModule?.["regression based forecast"]?.patient_pop_size,
                regulatoryScore: resModule?.["regression based forecast"]?.regulatory_score
              });
            }
            else{
              this.regressionForm.patchValue({
                severityScore: "",
                regressionCost: "",
                competitiveIndex: "",
                patientPopSize: "",
                regulatoryScore: ""
              });
            }
            if(resModule?.["scenario based forecast"]){
              this.scenarioForm.patchValue({
                baseUptake: resModule?.["scenario based forecast"]?.base_uptake,
                basePrice: resModule?.["scenario based forecast"]?.base_price,
                baseGrowth: resModule?.["scenario based forecast"]?.base_growth,
                baseProbability: resModule?.["scenario based forecast"]?.base_probability,
                optUptake: resModule?.["scenario based forecast"]?.opt_uptake,
                optPrice: resModule?.["scenario based forecast"]?.opt_price,
                optGrowth: resModule?.["scenario based forecast"]?.opt_growth,
                optProbability: resModule?.["scenario based forecast"]?.opt_probability,
                pessUptake: resModule?.["scenario based forecast"]?.pess_uptake,
                pessPrice: resModule?.["scenario based forecast"]?.pess_price,
                pessGrowth: resModule?.["scenario based forecast"]?.pess_growth,
                pessProbability: resModule?.["scenario based forecast"]?.pess_probability,
                patientCount: resModule?.["scenario based forecast"]?.patient_count
              });
            }
            else{
              this.scenarioForm.patchValue({
                baseUptake: "",
                basePrice: "",
                baseGrowth: "",
                baseProbability: "",
                optUptake: "",
                optPrice: "",
                optGrowth: "",
                optProbability: "",
                pessUptake: "",
                pessPrice: "",
                pessGrowth: "",
                pessProbability: "",
                patientCount: this.psData?.scenario_based_forecast?.base_patient
              });
            }
            if(resModule?.["monte carlo simulation"]){
              this.monteCarloForm.patchValue({
                numSimulations: resModule?.["monte carlo simulation"]?.num_simulations,
                growthMean: resModule?.["monte carlo simulation"]?.growth_mean,
                growthStd: resModule?.["monte carlo simulation"]?.growth_std,
                priceMin: resModule?.["monte carlo simulation"]?.price_min,
                priceMax: resModule?.["monte carlo simulation"]?.price_max,
                penetrationMin: resModule?.["monte carlo simulation"]?.penetration_min,
                penetrationMode: resModule?.["monte carlo simulation"]?.penetration_mode,
                penetrationMax: resModule?.["monte carlo simulation"]?.penetration_max,
                basePatientCount: this.psData?.monte_carlo_simulation?.base_patient,
              });
            }else{
              this.monteCarloForm.patchValue({
                basePatientCount: this.psData?.monte_carlo_simulation?.base_patient,
                numSimulations: "",
                growthMean: "",
                growthStd: "",
                priceMin: "",
                priceMax: "",
                penetrationMin: "",
                penetrationMode: "",
                penetrationMax: "",

              });
            }
         //------------------------------------------------------------------------------------------



            if(resModule?.["analog based forecast response"]){
              const findIndex = this.modalCompleted.findIndex(item => item.ps_method === "analog based forecast");

              console.log("findIndex 702", findIndex)
              this.modalCompleted[findIndex] = {
                ps_method: "analog based forecast",
                value: {
                  ...this.analogForm.value,
                  ...resModule?.["analog based forecast response"],
                  "analog based forecast response": resModule?.["analog based forecast response"]
                },
                isCompleted: true
              };

            }
            if(resModule?.["epidemiology based forecast response"]){
              const findIndex = this.modalCompleted.findIndex(item => item.ps_method === "epidemiology based forecast");
              console.log("findIndex", findIndex)
              this.modalCompleted[findIndex] = {
                ps_method: "epidemiology based forecast",
                value: {
                  ...this.epidemiologyForm.value,
                  ...resModule?.["epidemiology based forecast response"],
                  "epidemiology based forecast response": resModule?.["epidemiology based forecast response"]
                },
                isCompleted: true
              };
            }
            if(resModule?.["market share based forecast response"]){
              const findIndex = this.modalCompleted.findIndex(item => item.ps_method === "market share based forecast");
              console.log("findIndex", findIndex)
              this.modalCompleted[findIndex] = {
                ps_method: "market share based forecast",
                value: {
                  ...this.marketShareForm.value,
                  ...resModule?.["market share based forecast response"],
                  "market share based forecast response": resModule?.["market share based forecast response"]
                },
                isCompleted: true
              };
            }
            if(resModule?.["regression based forecast response"]){
              const findIndex = this.modalCompleted.findIndex(item => item.ps_method === "regression based forecast");
              console.log("findIndex", findIndex)
              this.modalCompleted[findIndex] = {
                ps_method: "regression based forecast",
                value: {
                  ...this.regressionForm.value,
                  ...resModule?.["regression based forecast response"],
                  "regression based forecast response": resModule?.["regression based forecast response"]
                },
                isCompleted: true
              };
            }
            if(resModule?.["scenario based forecast response"]){
              const findIndex = this.modalCompleted.findIndex(item => item.ps_method === "scenario based forecast");
              console.log("findIndex", findIndex)
              this.modalCompleted[findIndex] = {
                ps_method: "scenario based forecast",
                value: {
                  ...this.scenarioForm.value,
                  ...resModule?.["scenario based forecast response"],
                  "scenario based forecast response": resModule?.["scenario based forecast response"]
                },
                isCompleted: true
              };
            }
            if(resModule?.["monte carlo simulation response"]){
              const findIndex = this.modalCompleted.findIndex(item => item.ps_method === "monte carlo simulation");
              console.log("findIndex", findIndex)
              this.modalCompleted[findIndex] = {
                ps_method: "monte carlo simulation",
                value: {
                  ...this.monteCarloForm.value,
                  ...resModule?.["monte carlo simulation response"],
                  "monte carlo simulation response": resModule?.["monte carlo simulation response"]
                },
                isCompleted: true
              };
            }
          })
         
        },(error) => {
          console.log("error", error)
        })
      }
    }
  }
  clearData() {
    this.selectedSubMolecule = {};
    this.subMolecule = false;
    this.Molecule = false;
    this.DragData = {};
    this.brandname = "";
    this.analogForm.reset();
    this.epidemiologyForm.reset();
    this.marketShareForm.reset();
    this.regressionForm.reset();
    this.scenarioForm.reset();
    this.monteCarloForm.reset();
    this.drugInfoForm.reset();
    this.modalCompleted = [{
      value: {},
      isCompleted: false,
      ps_method: 'analog based forecast'
    },{
      value: {},
      isCompleted: false,
      ps_method: 'epidemiology based forecast'
    },{
      value: {},
      isCompleted: false,
      ps_method: 'market share based forecast'
    },{
      value: {},
      isCompleted: false,
      ps_method: 'regression based forecast'
    },{
      value: {},
      isCompleted: false,
      ps_method: 'scenario based forecast'
    },{
      value: {},
      isCompleted: false,
      ps_method: 'monte carlo simulation'
    }];
  }
  refreshData() {
    this.dashboardService.getRefreshData().subscribe((res) => {
      this.psData = res?.[0];

      this.regressionForm.patchValue({
        alpha: this.psData?.regression_based_forecast?.alpha,
        beta1: this.psData?.regression_based_forecast?.beta1,
        beta2: this.psData?.regression_based_forecast?.beta2,
        beta3: this.psData?.regression_based_forecast?.beta3,
        beta4: this.psData?.regression_based_forecast?.beta4,
        beta5: this.psData?.regression_based_forecast?.beta5
      });
      this.monteCarloForm.patchValue({
        basePatientCount: this.psData?.monte_carlo_simulation?.base_patient
      });
      this.drugInfoForm.patchValue({
        timeframe: this.psData?.timeframe
      });
      this.scenarioForm.patchValue({
        patientCount: this.psData?.scenario_based_forecast?.base_patient
      });
      this.analogForm.patchValue({
        alpha: this.psData?.analog_based_forecast?.alpha,
        beta: this.psData?.analog_based_forecast?.beta
      });
    
    });
 
  }
  get hasSelectedSubMolecule(): boolean {
    return this.selectedSubMolecule && Object.keys(this.selectedSubMolecule).length > 0;
  }
}
